__turbopack_context__.v({
  "copy": "PlasmicFooterBottom-module__poCS3G__copy",
  "desc": "PlasmicFooterBottom-module__poCS3G__desc",
  "footerBottom": "PlasmicFooterBottom-module__poCS3G__footerBottom",
  "img": "PlasmicFooterBottom-module__poCS3G__img",
  "left": "PlasmicFooterBottom-module__poCS3G__left",
  "logo": "PlasmicFooterBottom-module__poCS3G__logo",
  "right": "PlasmicFooterBottom-module__poCS3G__right",
  "security": "PlasmicFooterBottom-module__poCS3G__security",
  "sideEffect": "PlasmicFooterBottom-module__poCS3G__sideEffect",
  "sm": "PlasmicFooterBottom-module__poCS3G__sm",
  "smLink": "PlasmicFooterBottom-module__poCS3G__smLink",
  "soc": "PlasmicFooterBottom-module__poCS3G__soc",
  "socLink": "PlasmicFooterBottom-module__poCS3G__socLink",
  "ssl": "PlasmicFooterBottom-module__poCS3G__ssl",
  "sslLink": "PlasmicFooterBottom-module__poCS3G__sslLink",
  "trademark": "PlasmicFooterBottom-module__poCS3G__trademark",
  "trademark2": "PlasmicFooterBottom-module__poCS3G__trademark2",
  "truste": "PlasmicFooterBottom-module__poCS3G__truste",
  "trusteLink": "PlasmicFooterBottom-module__poCS3G__trusteLink",
  "wrapper": "PlasmicFooterBottom-module__poCS3G__wrapper",
});
